module.exports = __webpack_public_path__ + "img/jt-logo.45ab99ac.png";